/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useContext } from 'react'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { strCol, numCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import { getWsFuelCost, importWsFuelCost } from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUnits,
  getValidYearRange,
  isValidYearRange,
} from 'core'
import { Button, DatePicker, message } from 'antd'
import { ErrorContext } from 'context'
import CommonScreen from 'admin/component/CommonScreen'
// import { getPFuelCodeAtFuelCosteByClients } from 'marginanalysis/utils'
import moment from 'moment'

const title = 'Fuel Cost'

const WsFuelCostHeaders = [
  strCol({
    ident: 'unitid',
    display: 'Unit',
    width: 350,
    isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  dateTimeCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pfuelcode',
    display: 'Primary Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(pFuelCodeChioce),
  }),
  numCol({
    ident: 'fuelcost',
    display: 'Fuel Cost',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const WsFuelCost = ({
  targetInfo,
  // envConfig,
  // actionPermits,
  unitNameMap,
  validYearRange,
}) => {
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment(),
  ])
  const [importing, setImporting] = useState(false)
  const { setError } = useContext(ErrorContext)

  const withCriteria = (state, props, selectedUnits) => {
    return {
      start: selectedDateRangePicker[0],
      end: selectedDateRangePicker[1],
      units: (selectedUnits || []).filter(e => !!e).map(e => e.unitId),
    }
  }

  const headerWithFormatter = WsFuelCostHeaders.map(header =>
    header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => unitNameMap[value] || value,

          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unitid] || rowData.unitid,
        }
      : header
  )

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
        }}
      />
    )
  }

  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  const extraCriteriaAfterButton = ({ selectedUnits }) => {
    return (
      <Button
        loading={importing}
        onClick={() => {
          if (!beforeRetrieveValidation({ validYearRange })) return

          setImporting(true)
          importWsFuelCost(targetInfo)({
            start: selectedDateRangePicker[0],
            end: selectedDateRangePicker[1],
            units: (selectedUnits || []).filter(e => !!e).map(e => e.unitId),
          }).fork(setError, () => {
            message.info(
              'Data started importing, Please check data after sometime.'
            )
            setImporting(false)
          })
        }}
        style={{ marginLeft: '10px' }}
        type="danger"
        icon="thunderbolt"
      >
        Import Data
      </Button>
    )
  }

  return (
    <CommonScreen
      withUnitSelection
      screenCriteria={screenCriteria}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      withoutModify
      allowInsert={false}
      isEditableGrid={_ => false}
      autoRetrieve={false}
      isAdminScreen
      withCriteria={withCriteria}
      title={title}
      header={headerWithFormatter}
      retrieveTask={getWsFuelCost}
      altBy={u => u.unitid}
      sortOptions={WsFuelCostHeaders}
      initialSortOptions={WsFuelCostHeaders}
      widthOffset={50}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
  unitNameMap: getUnitNameMap(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(WsFuelCost)
